import React from "react"

const Dashboard=React.lazy(()=>import('./DashboardPage'))
const ClientPage=React.lazy(()=>import('./ClientPage'))
const EmployeePage=React.lazy(()=>import('./EmplyoeePage'))
const VendorPage=React.lazy(()=>import('./VendorPage'))
const ProjectPage=React.lazy(()=>import('./ProjectPage'))

export {
    Dashboard,
    ClientPage,
    EmployeePage,
    VendorPage,
    ProjectPage
}